import { client } from "../../client";
import { addTrack, addMusicCategory, resetMusicTree } from "../../client/addTrack";
import { isAudio } from "../../client/isAudio";

/**
 * Handles updated music list
 * @param {Array} args packet arguments
 */
export const handleFM = (args: string[]) => {
  client.resetMusicList();
  resetMusicTree();

  for (let i = 1; i < args.length - 1; i++) {
    const trackname = args[i];
    // Audio entries are songs; non-audio entries open collapsible categories.
    if (isAudio(trackname)) {
      addTrack(trackname);
    } else {
      addMusicCategory(trackname);
    }
  }
};
